<template>
  <main class="container-fluid" style="max-width: 500px">
    <div class="row m-3" v-if="erro">
      <div class="col card my-2 badge-danger text-center p-3 text-uppercase mt-3">
        {{ erro }}
      </div>
    </div>

    <div class="card my-5 px-5 py-3 shadow">
      <form @submit.prevent="resetpasswordinit" v-if="showUserInput && !MODULOS.SPORTHECA">
        <h4 class="my-3">Esqueceu a senha?</h4>
        <div class="mb-3">
          <label for="user" class="form-label">CPF ou CNPJ</label>
          <input class="form-control" type="text" id="user" placeholder="000.000.000-00" v-model="user.user"
            v-mask="['###.###.###-##', '##.###.###/####-##']" required />
        </div>
        <button class="btn mb-5 w-100" type="submit">
          Solicitar código de recuperação
        </button>
      </form>

      <form @submit.prevent="resetpasswordinitSportheca" v-if="!showCodeInput & MODULOS.SPORTHECA">
        <h4 class="my-3">Esqueceu a senha?</h4>
        <div class="mb-3">
          <label for="user" class="form-label">Email</label>
          <input class="form-control" type="text" id="email" placeholder="seu@email.com" v-model="user.email"
            required />
        </div>
        <button class="btn mb-5 w-100" type="submit">
          Recuperar senha
        </button>
      </form>

      <form @submit.prevent="resetpasswordconfirmcode" v-if="showCodeInput">
        <h6 class="my-3">
          Para alterar a senha da sua conta, você precisará informar o código de
          validação enviado por <strong>Email</strong> e <strong>SMS</strong>
        </h6>
        <div class="mb-3">
          <input placeholder="código de recuperação" class="form-control" type="text" id="code" v-model="user.codigo"
            v-mask="'######'" required />
        </div>
        <button class="btn mb-3 w-100" type="submit">Enviar</button>
        <button type="button" class="btn btn-secondary w-100 mb-5" v-on:click="resetpasswordinit">
          Solicitar novo código
        </button>
      </form>

      <div v-if="showPasswordInput && !MODULOS.SPORTHECA">
        <h4 class="my-3">Nova senha</h4>
        <div class="mb-3">
          <label for="newPassword" class="form-label">Insira a nova senha</label>
          <input class="form-control" type="password" id="newPassword" placeholder="* * * * *" v-model="user.password"
            required />
          <small>
            <strong>Sua senha deve conter:</strong>
            <ul>
              <li :class="[
      validarSenhaTamanho() ? 'text-success' : 'text-danger'
    ]">
                Pelo menos 6 caracteres
              </li>
              <li :class="[validarSenhaLetras() ? 'text-success' : 'text-danger']">
                Pelo menos uma letra
              </li>
              <li :class="[
      validarSenhaNumeros() ? 'text-success' : 'text-danger'
    ]">
                Pelo menos um número
              </li>
              <li :class="[
      validarSenhaCaracteresEspeciais()
        ? 'text-success'
        : 'text-danger'
    ]">
                Pelo menos um caractere especial
              </li>
            </ul>
          </small>
        </div>
        <button class="btn mb-5 w-100" type="button" @click="resetpasswordchange">
          Alterar senha
        </button>
      </div>
    </div>
    <Loading v-if="loading"></Loading>
  </main>
</template>

<script>
// @ is an alias to /src
import { APIService } from "../APIService";
const apiService = new APIService();
import { sha256 } from "../shared/helpers/helpers";
import Loading from "@/components/Loading.vue";

export default {
  name: "EsqueceuSenha",
  components: { Loading },
  data() {
    return {
      MODULOS: window.MODULOS,
      showCodeInput: false,
      showPasswordInput: false,
      showUserInput: true,
      loading: false,
      erro: "",
      user: {
        user: "",
        codigo: "",
        password: "",
        email: ""
      }
    };
  },
  mounted() { },
  methods: {
    validarSenha() {
      return (
        this.validarSenhaTamanho() &&
        this.validarSenhaNumeros() &&
        this.validarSenhaLetras() &&
        this.validarSenhaCaracteresEspeciais()
      );
    },
    validarSenhaNumeros() {
      var numeros = /([0-9])/;
      return this.user.password.match(numeros);
    },
    validarSenhaLetras() {
      var alfabeto = /([a-zA-Z])/;
      return this.user.password.match(alfabeto);
    },
    validarSenhaCaracteresEspeciais() {
      var chEspeciais = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;
      return this.user.password.match(chEspeciais);
    },
    validarSenhaTamanho() {
      return this.user.password.length >= 6;
    },
    resetpasswordinitSportheca() {
      this.erro = "";
      this.loading = true;
      apiService
        .resetpasswordinitSportheca({ email: this.user.email })
        .then(() => {
          this.$swal({
            title: "Sucesso!",
            text:
              "Você recebeu um email com as instruções para alterar sua senha."
          }).then(() => {
            this.$router.push({
              path: `/login/`,
              query: { nextUrl: this.$route.query.nextUrl }
            });
            this.loading = false;
          });
        })
        .catch(error => {
          this.erro = error.response.data.title;
          this.loading = false;
          window.scrollTo(0, 0);
        });
    },
    resetpasswordinit() {
      this.erro = "";
      this.loading = true;
      apiService
        .resetpasswordinit({
          usuario: this.removeMask(this.user.user)
        })
        .then(() => {
          this.showUserInput = false;
          this.showCodeInput = true;
          this.showPasswordInput = false;
          this.loading = false;
        })
        .catch(error => {
          this.erro = error.response.data.title;
          this.loading = false;
          window.scrollTo(0, 0);
        });
    },
    resetpasswordconfirmcode() {
      this.erro = "";
      this.loading = true;
      apiService
        .resetpasswordconfirmcode(this.user.codigo)
        .then(() => {
          this.showUserInput = false;
          this.showCodeInput = false;
          this.showPasswordInput = true;
          this.loading = false;
        })
        .catch(error => {
          this.erro = error.response.data.title;
          this.loading = false;
          window.scrollTo(0, 0);
        });
    },
    resetpasswordchange() {
      this.erro = "";
      if (this.validarSenha()) {
        this.loading = true;
        apiService
          .resetpasswordchange(this.user.codigo, {
            usuario: this.removeMask(this.user.user),
            hashSenha: sha256(this.user.password)
          })
          .then(() => {
            this.loading = false;

            this.$swal({
              title: "Senha alterada com sucesso.",
              confirmButtonText: "Ok",
              showCancelButton: false
            }).then(res => {
              if (res.isConfirmed) {
                this.$router.push(`/login`);
              }
            });
          })
          .catch(error => {
            this.erro = error.response.data.title;
            this.loading = false;
            window.scrollTo(0, 0);
          });
      } else {
        this.erro = "Senha inválida!";
        window.scrollTo(0, 0);
      }
    },
    removeMask(n) {
      return n.replace(/\D/gm, "");
    }
  }
};
</script>
<style scoped lang="scss">
button {
  background: var(--cor-principal);
  color: var(--cor-texto);
}

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.a-divider.a-divider-break {
  text-align: center;
  position: relative;
  top: 2px;
  padding-top: 1px;
  margin-bottom: 14px;
  line-height: 0;

  &:after {
    content: "";
    width: 100%;
    background-color: transparent;
    display: block;
    height: 1px;
    border-top: 1px solid #e7e7e7;
    position: absolute;
    top: 50%;
    margin-top: -1px;
    z-index: 1;
  }

  h5 {
    line-height: 1;
    font-size: 12px;
    color: #767676;
    font-weight: 400;
    z-index: 2;
    position: relative;
    display: inline-block;
    background-color: #fff;
    padding: 0 8px 0 7px;
  }
}
</style>
